import { render } from "./HomeTestimony.vue?vue&type=template&id=73c94fe4&scoped=true"
import script from "./HomeTestimony.vue?vue&type=script&lang=js"
export * from "./HomeTestimony.vue?vue&type=script&lang=js"

import "./HomeTestimony.vue?vue&type=style&index=0&id=73c94fe4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c94fe4"]])

export default __exports__